export default __webpack_public_path__ + "static/media/sealandscape.5c1dfa80.jpg";